import { LeadForm } from "@/components/LeadForm";

const defaults = {
  de: {
    headline: "Sagen Sie mir kurz, was ansteht",
    text: "Neuer Shop, Anpassung am Theme oder mehr Umsatz pro Besucher: Sie erhalten innerhalb von 48 Stunden eine kurze Einschätzung zu Ihrem Vorhaben, den empfohlenen nächsten Schritt und, soweit anhand Ihrer Angaben möglich, einen groben Kostenrahmen. Kostenlos und unverbindlich.",
  },
  en: {
    headline: "Tell me what is coming up",
    text: "New store, theme work or more revenue per visitor: within 48 hours you get a short read on your project, the recommended next step and, as far as your details allow, a rough cost range. Free and without obligation.",
  },
} as const;

/**
 * Wiederverwendbarer Lead-Block für Unterseiten:
 * Text links, Formular rechts, damit Besucher nicht erst nach /kontakt klicken müssen.
 */
export function LeadSection({
  source,
  lang = "de",
  headline,
  text,
}: {
  source: string;
  lang?: "de" | "en";
  headline?: string;
  text?: string;
}) {
  const d = defaults[lang];
  return (
    <section id="anfrage" data-lead-block className="veil scroll-mt-20 border-t border-border/60 py-16 md:py-20">
      <div className="mx-auto grid max-w-5xl gap-10 px-5 md:grid-cols-2 md:items-center">
        <div>
          <h2 className="text-3xl font-bold md:text-4xl">{headline ?? d.headline}</h2>
          <p className="mt-5 leading-relaxed text-muted-foreground">{text ?? d.text}</p>
          <ol className="mt-6 grid gap-2 text-sm text-muted-foreground">
            {(lang === "de"
              ? ["Sie schildern kurz, was Sie erreichen möchten.", "Ich prüfe den sinnvollsten Weg und den Aufwand.", "Sie entscheiden in Ruhe, ob Sie weitermachen möchten."]
              : ["Tell me briefly what you want to achieve.", "I review the most sensible route and likely effort.", "You decide without pressure whether to continue."]
            ).map((step, index) => (
              <li key={step} className="flex items-start gap-3">
                <span className="font-semibold text-primary">{index + 1}.</span>
                <span>{step}</span>
              </li>
            ))}
          </ol>
        </div>
        <LeadForm source={source} lang={lang} />
      </div>
    </section>
  );
}
